module.exports = __webpack_public_path__ + "static/media/feb1120194.a10d8a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feb1120194.png
// module id = 1684
// module chunks = 0